import React from "react";
import SelectedStoreSales from "./SelectedStoreSales";
import Summary from "./Summary";
import { Grid } from "@material-ui/core";

const StoreInsight: React.FC = () => {
    return (
        <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
                <Summary />
            </Grid>
            <Grid item md={6} xs={12}>
                <SelectedStoreSales />
            </Grid>
        </Grid>
    );
};

export default StoreInsight;
